import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const OutcomeAtScene = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Outcome At Scene</InputLabel>
      <Select
        value={moduleValues?.['Outcome At Scene'] ?? ''}
        label="Outcome At Scene"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Outcome At Scene']: e.target.value,
          }))
        }
      >
        {[
          'ROSC (Return of Spontaneous Circulation)',
          'Deceased',
          'Transported to Hospital',
        ].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default OutcomeAtScene
